import {SlotGame} from "@nolimit/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimit/slot-launcher/bin/NolimitPlugin";
import {Logger, LogLevel} from "@nolimit/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimit/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimit/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimit/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimit/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimit/slot-launcher/bin/NolimitApplication";
import {AssetsConfig} from "@nolimit/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimit/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimit/slot-game/bin/asset/ResourcesGroupName";
import {TemplateAsset, TemplateLoader} from "@nolimit/slot-launcher/bin/loader/TemplateLoader";
import {NolimitConfig} from "@nolimit/slot-launcher/bin/settings/NolimitConfig";

import {Speedster} from "./debug/Speedster";
import {FITH2FreespinIntro} from "./view/FITH2FreespinIntro";
import {FITH2FreespinOutro} from "./view/FITH2FreespinOutro";
import {FITH2WinCapView} from "./view/FITH2WinCapView";
import {FITH2SoundManager} from "./sound/FITH2SoundManager";
import {FITH2Background} from "./view/FITH2Background";
import {FITH2Model} from "./server/FITH2Model";
import {FITH2AvalancheReelModel} from "./reels/FITH2AvalancheReelModel";
import {FITH2ReelArea} from "./reels/FITH2ReelArea";
import {FITH2IdleNormalPresentation} from "./gameflow/FITH2IdleNormalPresentation";
import {FITH2NormalBetPresentation} from "./gameflow/FITH2NormalBetPresentation";
import {FITH2FSBetPresentation} from "./gameflow/freespin/FITH2FSBetPresentation";
import {FITH2FSResultPresentation} from "./gameflow/freespin/FITH2FSResultPresentation";
import {FITH2NormalResultPresentation} from "./gameflow/FITH2NormalResultPresentation";
import {FITH2FSWinPresentation} from "./gameflow/freespin/FITH2FSWinPresentation";
import {FITH2FSIdlePresentation} from "./gameflow/freespin/FITH2FSIdlePresentation";
import {FITH2AvalancheIdlePresentation} from "./gameflow/avalanche/FITH2AvalancheIdlePresentation";
import {FITH2GameMode} from "./server/FITH2GameMode";
import {ISymbolValues} from "./server/IFITH2Data";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";
import {FITH2WinPresentation} from "./gameflow/FITH2WinPresentation";
import {FITH2InitialWinView} from "./view/FITH2InitialWinView";
import {FITH2TotalWinView} from "./view/FITH2TotalWinView";
import {FITH2BigWinView} from "./view/FITH2BigWinView";
import {FITH2GameView} from "./view/FITH2GameView";
import {FITH2ReelBackground} from "./view/FITH2ReelBackground";
import {FITH2SymbolAnimation} from "./view/FITH2SymbolAnimation";
import {ExtraFreespinAwardView} from "./view/ExtraFreespinAwardView";
import {HighSymbolReelArea} from "./view/HighSymbolReelArea";
import {XBetController} from "./view/XBetController";
import {FITH2ReelAnticipation} from "./view/FITH2ReelAnticipation";
import {FITH2FullScreenDimmer} from "./view/FITH2FullScreenDimmer";
import {FITH2GameAssets} from "./FITH2GameAssets";
import {FITH2GameConfig} from "./configs/FITH2GameConfig";
import {FITH2Helper} from "./utils/FITH2Helper";
import {FITH2ReelForeground} from "./view/FITH2ReelForeground";
import {TopCarts} from "./view/freespin/TopCarts";
import {FreespinReelArea} from "./reels/freespin/FreespinReelArea";
import {MultiplierView} from "./view/MultiplierView";
import {ReelTopBar} from "./view/ReelTopBar";
import {ChestRow} from "./view/ChestRow";
import {FreespinsLeftView} from "./view/FreespinsLeftView";
import {FITH2WildWinAnimation} from "./view/FITH2WildWinAnimation";
import {WildMining} from "./view/WildMining";
import {FITH2Logo} from "./view/FITH2Logo";
import {CoinRain} from "./components/CoinRain";

export class FireInTheHole2 extends SlotGame {
    public static boostedName:string = "BOOSTED_BET";
    public static model:FITH2Model;
    public static gameFlowController:GameFlowController;
    public static assetLoader:AssetLoader;
    public static reels:FITH2AvalancheReelModel[];
    public static freespinIntro:FITH2FreespinIntro;
    public static freespinOutro:FITH2FreespinOutro;
    public static winCapScreen:FITH2WinCapView;
    public static reelArea:FITH2ReelArea;
    public static background:FITH2Background;
    public static initialWinView:FITH2InitialWinView;
    public static totalWinView:FITH2TotalWinView;
    public static bigWinView:FITH2BigWinView;
    public static extraFreespinAwardView:ExtraFreespinAwardView;
    public static gameViewContainer:FITH2GameView;
    public static reelFrame:FITH2ReelForeground;
    public static logo:FITH2Logo;
    public static reelBackground:FITH2ReelBackground;
    public static symbolAnimation:FITH2SymbolAnimation;
    public static wildWinAnimation:FITH2WildWinAnimation;
    public static xBetController:XBetController;
    public static emptyLayerBelowCollector:PIXI.Container;
    public static fullScreenDimmer:PIXI.Container;
    public static highSymbolRealArea:HighSymbolReelArea;
    public static wildMining:WildMining;
    public static reelAnticipation:FITH2ReelAnticipation;
    public static freespinReelArea:FreespinReelArea;
    public static topCarts:TopCarts;
    public static chestRow:ChestRow;
    public static multiplier:MultiplierView;
    public static fsLeftView:FreespinsLeftView;
    public static reelTopBar:ReelTopBar;
    public static coinRain:CoinRain;
    private _defaultSymbolValues:ISymbolValues = {
        "L1" : {3 : 3, 4 : 4, 5 : 8, 6 : 15},
        "L2" : {3 : 3, 4 : 4, 5 : 8, 6 : 14},
        "L3" : {3 : 3, 4 : 4, 5 : 8, 6 : 12},
        "L4" : {3 : 2, 4 : 3, 5 : 6, 6 : 12},
        "L5" : {3 : 2, 4 : 3, 5 : 6, 6 : 10},
        "M1" : {3 : 10, 4 : 25, 5 : 50, 6 : 75},
        "M2" : {3 : 5, 4 : 8, 5 : 20, 6 : 30},
        "M3" : {3 : 4, 4 : 6, 5 : 15, 6 : 25},
        "M4" : {3 : 4, 4 : 6, 5 : 12, 6 : 22},
        "M5" : {3 : 4, 4 : 5, 5 : 10, 6 : 20}
    }

    constructor() {
        super();
    }

    public init():Promise<NolimitPlugin> {
        return super.init().then((value:NolimitPlugin) => {
            if(NolimitConfig.isDevMode) {
                (<any>globalThis).__PIXI_APP__ = NolimitApplication.pixiApp;
            }
            FireInTheHole2.model = new FITH2Model(SlotGame.apiPlugin, true);
            FireInTheHole2.gameFlowController = new GameFlowController(SlotGame.apiPlugin, FireInTheHole2.model);
            FireInTheHole2.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            const winPres = new FITH2WinPresentation();
            const normalBet = new FITH2NormalBetPresentation();
            const normalResult = new FITH2NormalResultPresentation();

            FireInTheHole2.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, new FITH2IdleNormalPresentation()],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            FireInTheHole2.gameFlowController.addGameModeFlowStatePresentationMap(FITH2GameMode.NORMAL_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, new FITH2AvalancheIdlePresentation()],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));

            FireInTheHole2.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, new FITH2FSIdlePresentation()],
                [FlowState.BET, new FITH2FSBetPresentation()],
                [FlowState.RESULT, new FITH2FSResultPresentation()],
                [FlowState.WIN, new FITH2FSWinPresentation()]
            ]));

            return value;
        });
    }

    public async getReady():Promise<NolimitPlugin> {
        //Show intro and load game assets
        const value = await super.getReady();
        const fontLoader = new FontLoader(NolimitApplication.resourcePath);

        AssetsConfig.addToAssetsConfig(FITH2GameAssets.RESOURCES_GROUPS);
        FireInTheHole2.assetLoader = new AssetLoader(FireInTheHole2.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        await Promise.all([fontLoader.load(), FireInTheHole2.assetLoader.load(ResourcesGroupName.MAIN)]);
        await FireInTheHole2.createViewsAndComponents();
        return value;
    }

    public async getReadyToStart():Promise<NolimitPlugin> {
        //Game assets loaded, showing intro, waiting for user to start game.
        if(FireInTheHole2.model.isRestore) {
            FireInTheHole2.reelFrame.updateWays(FireInTheHole2.model.totalWays);
            FireInTheHole2.reelTopBar.updateBarsOnRestore();
            const totalWin:number = FireInTheHole2.model.initData.accumulatedRoundWin - FireInTheHole2.model.initData.accumulatedFSRoundWin;
            FireInTheHole2.keypadPlugin.setWin(totalWin, true, FITH2Helper.isWinBelowStake(totalWin));
        }
        return await super.getReadyToStart();
    }

    public async start():Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        FITH2SoundManager.playAmbientLoop(0.1);
        const value = await super.start();
        FireInTheHole2.gameFlowController.start();
        FireInTheHole2.setMode(FireInTheHole2.model.data.mode);
        FireInTheHole2.multiplier.update((FireInTheHole2.model.data.mode[0] === "F" || FireInTheHole2.model.freespinTriggeredThisSpin)? FireInTheHole2.model.fsMultiplier : FireInTheHole2.model.data.multiplier);

        if (FireInTheHole2.apiPlugin.isReplay) {
            if (FireInTheHole2.model.boostedBet) {
                FireInTheHole2.xBetController.featureEnabled = true;
            } else {
                FireInTheHole2.xBetController.featureEnabled = false;
            }
        }
        FireInTheHole2.xBetController.start();
        return value;
    }

    private static addLayer(layer:any):any {
        NolimitApplication.addLayerAt(layer.name, layer, 0);
        return layer;
    }

    public static setMode(mode:string):void {
        const isNormal:boolean = FITH2Helper.isNormal(mode);
        FireInTheHole2.reelArea.visible = isNormal;
        FireInTheHole2.symbolAnimation.visible = isNormal;
        FireInTheHole2.wildWinAnimation.visible = isNormal;
        FireInTheHole2.highSymbolRealArea.visible = isNormal;
        FireInTheHole2.freespinReelArea.visible = !isNormal;
        FireInTheHole2.background.setMode(mode);
        FireInTheHole2.logo.setMode(mode);
        FireInTheHole2.reelTopBar.setMode(mode);
        FireInTheHole2.reelBackground.setMode(mode);
        FireInTheHole2.multiplier.setMode(mode);
        FireInTheHole2.fsLeftView.setMode(mode);
    }

    private static createViewsAndComponents() {
        if(NolimitConfig.isDevMode) {
            NolimitApplication.addLayerAt("SPEEDSTER", new PIXI.Container(), 0);
            FireInTheHole2.addLayer(new Speedster());
        }

        FireInTheHole2.symbolAnimation = new FITH2SymbolAnimation();
        FireInTheHole2.wildWinAnimation = new FITH2WildWinAnimation();
        FireInTheHole2.highSymbolRealArea = new HighSymbolReelArea();
        FireInTheHole2.wildMining = new WildMining();
        FireInTheHole2.reelArea = new FITH2ReelArea();
        FireInTheHole2.freespinReelArea = new FreespinReelArea();

        FireInTheHole2.background = new FITH2Background();
        FireInTheHole2.gameViewContainer = new FITH2GameView();
        FireInTheHole2.reelFrame = new FITH2ReelForeground();
        FireInTheHole2.logo = new FITH2Logo();
        FireInTheHole2.reelBackground = new FITH2ReelBackground();
        FireInTheHole2.initialWinView = new FITH2InitialWinView();
        FireInTheHole2.emptyLayerBelowCollector = new PIXI.Container();
        FireInTheHole2.reelAnticipation = new FITH2ReelAnticipation();
        FireInTheHole2.multiplier = new MultiplierView();
        FireInTheHole2.fsLeftView = new FreespinsLeftView();
        FireInTheHole2.topCarts = new TopCarts();
        FireInTheHole2.chestRow = new ChestRow();
        FireInTheHole2.reelTopBar = new ReelTopBar();

        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.background);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.reelBackground);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.reelAnticipation);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.reelArea);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.freespinReelArea);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.highSymbolRealArea);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.reelTopBar);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.reelFrame);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.symbolAnimation);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.wildWinAnimation);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.wildMining);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.fsLeftView);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.multiplier);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.topCarts);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.logo);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.emptyLayerBelowCollector);
        FireInTheHole2.gameViewContainer.addChild(FireInTheHole2.initialWinView);

        NolimitApplication.addLayerAt(FireInTheHole2.gameViewContainer.name, FireInTheHole2.gameViewContainer, 0);

        FireInTheHole2.xBetController = new XBetController();
        NolimitApplication.addLayerAt(FireInTheHole2.xBetController.name, FireInTheHole2.xBetController, 1);

        FireInTheHole2.fullScreenDimmer = new FITH2FullScreenDimmer();
        NolimitApplication.addLayerAt(FireInTheHole2.fullScreenDimmer.name, FireInTheHole2.fullScreenDimmer, 2);

        FireInTheHole2.totalWinView = new FITH2TotalWinView();
        NolimitApplication.addLayerAt(FireInTheHole2.totalWinView.name, FireInTheHole2.totalWinView, 3);

        FireInTheHole2.coinRain = new CoinRain();
        NolimitApplication.addLayerAt(FireInTheHole2.coinRain.name, FireInTheHole2.coinRain, 4);

        FireInTheHole2.bigWinView = new FITH2BigWinView();
        NolimitApplication.addLayerAt(FireInTheHole2.bigWinView.name, FireInTheHole2.bigWinView, 5);

        FireInTheHole2.extraFreespinAwardView = new ExtraFreespinAwardView();
        NolimitApplication.addLayerAt(FireInTheHole2.extraFreespinAwardView.name, FireInTheHole2.extraFreespinAwardView, 6);

        FireInTheHole2.freespinIntro = new FITH2FreespinIntro();
        NolimitApplication.addLayerAt(FireInTheHole2.freespinIntro.name, FireInTheHole2.freespinIntro, 7);

        FireInTheHole2.freespinOutro = new FITH2FreespinOutro();
        NolimitApplication.addLayerAt(FireInTheHole2.freespinOutro.name, FireInTheHole2.freespinOutro, 8);

        FireInTheHole2.winCapScreen = new FITH2WinCapView();
        NolimitApplication.addLayerAt(FireInTheHole2.winCapScreen.name, FireInTheHole2.winCapScreen, 9);


        FireInTheHole2.reels = [];
        for(let i:number = 0; i < FITH2GameConfig.reel_num; i++) {
            const reel = new FITH2AvalancheReelModel(i);
            FireInTheHole2.reels.push(reel);
        }
    }

    private static getSymbolString(key:string, data:{ [numSymbols:number]:number }):string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
            
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">6</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[6] * 0.05}">${data[6] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">5</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">4</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span style="margin-left: 2.38em ;padding-right:1em" class="number">3</span>
                    <span style="margin-left: 0.1em" class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    public getPaytable():Promise<string> {
        const templateLoader:TemplateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());
        templateLoader.add({
            name : "Paytable",
            url : "nolimit/screens/paytable.mustache"
        });
        let symbolDataValueData:ISymbolValues = this._defaultSymbolValues;
        if(FireInTheHole2.model.initData.symbolValues) {
            symbolDataValueData = FireInTheHole2.model.initData.symbolValues;
            Logger.logDev("Using symbolValues from INIT data");
        } else {
            Logger.logDev("Using default symbolValues");
        }
        return templateLoader.load().then((assets:TemplateAsset[]) => {
            for(let asset of assets) {
                if(asset.name === "Paytable" && asset.loadedData) {
                    for(let key in symbolDataValueData) {
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, FireInTheHole2.getSymbolString(key, symbolDataValueData[key]))
                    }
                    return asset.loadedData;
                }
            }
            throw new Error("FITH2 could not load Paytable");
        });
    }

    getNoWinGameData():any {
        return {
            reels : [["M5", "S", "D", "D", "D", "D"], ["L1", "M4", "L2", "BA", "D", "D"], ["M1", "L3", "L2", "D", "D", "D"], ["M5", "L2", "D", "D", "D", "D"], ["M5", "M2", "M5", "BA", "BA", "BA"], ["M2", "M1", "D", "D", "D", "D"]],
            evaluatedArea : [["M5", "S", "D", "D", "D", "D"], ["L1", "M4", "L2", "BA", "D", "D"], ["M1", "L3", "L2", "D", "D", "D"], ["M5", "L2", "D", "D", "D", "D"], ["M5", "M2", "M5", "BA", "BA", "BA"], ["M2", "M1", "D", "D", "D", "D"]],
            betWayWins : [],
            totalSpinWinnings : 0,
            accumulatedRoundWin : 0,
            playedBetValue : 1.6,
            mode : "NORMAL",
            nextMode : "NORMAL",
            wasFeatureBuy : false,
            brokeTheBank : false,
            freespinsTriggeredThisSpin : false,
            freespinsPlayed : 0,
            freespinsLeft : 0,
            boostedBet : false,
            serverTestInfo : {},
            totalSpinsPlayed : 1,
            symbolSizes : [[1, 1, 1, 1, 1, 1], [1, 1, 1, 1, 1, 1], [1, 1, 1, 1, 1, 1], [1, 1, 1, 1, 1, 1], [1, 1, 1, 1, 1, 1], [1, 1, 1, 1, 1, 1]],
            removedSymbols : [["M5", "S", "D", "D", "D", "D"], ["L1", "M4", "L2", "BA", "D", "D"], ["M1", "L3", "L2", "D", "D", "D"], ["M5", "L2", "D", "D", "D", "D"], ["M5", "M2", "M5", "BA", "BA", "BA"], ["M2", "M1", "D", "D", "D", "D"]],
            multiplier : 1.0,
            coinValuesPreviousSpin : [[0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0]],
            coinValues : [[0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0]],
            upgradeColumn : [false, false, false, false],
            accumulatedFSRoundWin : 0,
            dynamiteHitCoordinates : [],
            necromancerHitCoordinates : [],
            waysWonTotalRound : 0,
            beforeFreespinsArea : [],
            scatterCount: 1,
            reelsAfterCollapse : [],
            wildMiningTriggered : false
        };
    }
}